<script setup>
import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net-bs5";
import DataTablesButtons from "datatables.net-buttons-bs5";
import DataTablesSelect from "datatables.net-select-bs5";
import "datatables.net-buttons/js/buttons.html5";

import useKpiTable from "@/scripts/Courses/Kpi/kpiTable";

DataTable.use(DataTablesCore);
DataTable.use(DataTablesButtons);
DataTable.use(DataTablesSelect);

const { columns, tableData, tableOptions, onSelect, onDeselect } =
  useKpiTable();
</script>

<template>
  <div class="table-responsive">
    <DataTable
      :data="tableData"
      :columns="columns"
      :options="tableOptions"
      @select="(event, dt, type) => onSelect({ event, dt, type })"
      @deselect="(event, dt, type) => onDeselect({ event, dt, type })"
      class="datatable-css table table-hover table-spacing text-nowrap"
      width="100%"
    >
    </DataTable>
  </div>
</template>

<style>
.table-responsive {
  overflow-x: auto;
}
.table-spacing {
  margin: 5px 0 !important;
}
</style>
